import { canTrackMixpanel } from "./consent";
import { trackMixpanelEvent } from "./mixpanel";
import { toMixpanelSummaryProps } from "./studentAggregation";
import { getSafeUserContext } from "./context";

export const trackProductEvent = (eventName, props, user, options = {}) => {
  if (!canTrackMixpanel(user, options)) return;
  const context = getSafeUserContext(user);
  trackMixpanelEvent(eventName, { ...context, ...props });
};

export const trackAggregatedStudentSummary = (summary, user) => {
  if (!canTrackMixpanel(user)) return;
  const props = toMixpanelSummaryProps(summary, { role: user?.role });
  if (!props) return;
  trackMixpanelEvent("wellness_summary", props);
};
